export default "__VITE_ASSET__d08a1ec2__"